import { memo } from 'react'
import PropTypes from 'prop-types'
import { Card } from '@leroy-merlin-br/backyard-react-ui'

import { GenericCarousel } from 'reactGarden/GenericCarousel'

import { CouponContainer } from 'lmcv/containers/Coupon'

import { CarouselSkeleton } from '../Skeleton'
import * as S from '../styled'

function Percentage ({ data }) {
  const Carousel = () => {
    const carouselProps = {
      slidesPerView: 'auto',
      spaceBetween: 15,
      hasOffset: false
    }

    return (
        <GenericCarousel {...carouselProps}>
          {data.payload.map(data => {
            return <CouponContainer key={data.id} {...data} />
          })}
        </GenericCarousel>
    )
  }

  return (
    <Card
      title="Minhas Vantagens"
      addons={<S.Link to="/minhas-vantagens">Ver todos</S.Link>}
    >
      {data.isRequest ? <CarouselSkeleton size={5} /> : <Carousel />}
    </Card>
  )
}

Percentage.propTypes = {
  data: PropTypes.shape({
    isRequired: PropTypes.bool,
    payload: PropTypes.arr
  }).isRequired
}

export default memo(Percentage)
